import { StyleSheet } from "@react-pdf/renderer";
const pdfStyles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 120,
    paddingHorizontal: 35,
  },
  heading: {
    fontSize: 14,
    textAlign: "left",
    fontFamily: "Montserrat",
    fontWeight: 700,
    textTransform: "uppercase",
  },
  title: {
    fontSize: 30,
    textAlign: "center",
    fontFamily: "Oswald",
    textTransform: "uppercase",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
    padding: 4,
  },
  bordered: {
    borderBottomColor: "#c7c7c7",
    borderBottomWidth: "2",
    borderBottomStyle: "solid",
  },
  column: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    padding: 4,
  },
  doubleColumn: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    flex: 3,
    padding: 4,
  },
  text: {
    fontSize: 10,
    textAlign: "left",
    fontFamily: "Montserrat",
  },
  price: {
    fontSize: 13,
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#008af4",
    textAlign: "right",
  },
});

export default pdfStyles;
